/**
 * Licensed Materials - Property of IBM
 *
 * "Restricted Materials of IBM"
 *
 * (C) Copyright IBM Corp. 2019, 2020
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import React, { Component } from 'react';
import PropTypes from 'util/PropTypes';
import { observer } from 'mobx-react';
import Flyout from 'components/flyout/Flyout';
import { PLACEMENTS, ALIGNMENTS } from 'components/flyout/Flyout';
import { Button, TruncatedText, Separator } from '@ba/ba-ui-carbon-toolkit';
import StringResources from '../../../nls/StringResources';
import reset32 from '@ba/ba-graphics/dist/icons-js/reset_32.js';
import Config from './Config';
import './OverrideList.scss';

@observer
class OverrideList  extends Component {
	/***
	 *@constructor
	 **/
	constructor(props) {
		super(props);
		this.state = {
			showOverrideListFlyout: false
		};
	}

	componentDidMount() {
		document.addEventListener('mousedown', this._onClose.bind(this));
		document.addEventListener('touchstart', this._onClose.bind(this));
	}

	componentWillUnmount() {
		document.removeEventListener('mousedown', this._onClose.bind(this));
		document.removeEventListener('touchstart', this._onClose.bind(this));
	}

	render() {
		const overrideFields = this.props.overrideFields;
		const numberOfOverride = overrideFields.length;
		if(numberOfOverride === 0) {
			return null;
		}
		const numberOfOverridesText = StringResources.get('relationshipGraph_number_of_overrides', {
			number: numberOfOverride > Config.max_number_override_badge_shown ? StringResources.get('relationshipGraph_more_overrides_than_max_indicator', {
				number: Config.max_number_override_badge_shown
			}) : numberOfOverride
		});
		return (
			<div
				className= "overrideList"
				ref= {
					(node) => {
						this._overrideListRef = node;
					}
				}
			>
				<div
					className= "overrideListBadge"
					tabIndex= "0"
					arial-label= {numberOfOverridesText}
					onClick= {this._toggle.bind(this)}
					onKeyDown={this._onKeyDown.bind(this)}
					onTouchEnd={this._toggle.bind(this)}
					ref= {
						(node) => {
							this._overrideListBadgeRef = node;
						}
					}
				>
					{numberOfOverridesText}
				</div>
				{this._renderOverrideListFlyout(overrideFields)}
			</div>
		);
	}

	_onClose(event) {
		if(this._overrideListRef && !this._overrideListRef.contains(event.target)) {
			this.setState({
				showOverrideListFlyout: false
			});
		}
	}

	_renderOverrideListFlyout(overrideFields) {
		if (this.state.showOverrideListFlyout) {
			return <Flyout
				triggerNode={this._overrideListBadgeRef}
				className="overrideListFlyout"
				placement={PLACEMENTS.BOTTOM}
				alignment={ALIGNMENTS.RIGHT}
			>
				{this._renderList(overrideFields)}
			</Flyout>;
		} else {
			return null;
		}
	}

	_renderList(overrideFields) {
		const overrideListEntryClassName = 'overrideListFlyout-list__listEntry';
		return <div
			className="overrideListFlyout-list"
		>
			{(() => {
				return overrideFields.map((overrideField, index) => {
					return (
						<React.Fragment
							key={index}
						>
							<div
								className= {overrideListEntryClassName}
							>
								<TruncatedText
									value={overrideField.fieldLabel}
									title={overrideField.fieldID}
									className="overrideListFlyout-list__listEntry__field"
								/>
								<div
									className="overrideListFlyout-list__listEntry__action"
								>
									<span
										className="overrideListFlyout-list__listEntry__action__text"
									>
										{StringResources.get(`relationshipGraph_override_action_${overrideField.action}`)}
									</span>
									<Button
										className="overrideListFlyout-list__listEntry__action__cancelButton"
										iconSize="small"
										variant="icon"
										intent="primary"
										iconLeft={reset32.id}
										aria-label={StringResources.get('relationshipGraph_cancel_override')}
										onClick={() => this.props.cancelAction(overrideField.action, overrideField.fieldID)}
									/>
								</div>
							</div>
							{index < overrideFields.length - 1 ? <Separator className="overrideListFlyout-list__separator"/> : null}
						</React.Fragment>
					);
				});
			})()}
		</div>;
	}

	_onKeyDown(event) {
		switch (event.key) {
			case ' ':
				break;// space
			case 'Enter':
				this._toggle();
				break;
		}
	}

	_toggle() {
		this.setState({
			showOverrideListFlyout: !this.state.showOverrideListFlyout
		});
	}
}

OverrideList.propTypes = {
	overrideFields: PropTypes.array,
	cancelAction: PropTypes.function
};


export default OverrideList ;



// WEBPACK FOOTER //
// ./src/js/components/startingPoints/relationshipGraph/OverrideList.js